// extracted by mini-css-extract-plugin
export const logo = "Logo-module--logo--3IPyO";
export const g = "Logo-module--g--3kQdm";